const NATIONWIDE_MARKETPLACE_ID = 5

const initial = {
  marketPlace: NATIONWIDE_MARKETPLACE_ID,
  data: true,
  loading: false
}

export default function marketplace(state = initial, action) {
  switch (action.type) {
    default:
      return state
  }
}
